import { render, staticRenderFns } from "./TextObjectMenu.vue?vue&type=template&id=7f8d7728&"
import script from "./TextObjectMenu.vue?vue&type=script&lang=ts&"
export * from "./TextObjectMenu.vue?vue&type=script&lang=ts&"
import style0 from "./TextObjectMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports